import { useState } from 'react';
import { Link } from 'react-router-dom';
import { HamburgerMenu } from './HamburgerMenu';
import { useRulesetIdFromUrl } from '../../hooks/useUrlRuleset';
import { getRulesetConfig } from '@character-creator/data';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const rulesetId = useRulesetIdFromUrl();
  const config = getRulesetConfig(rulesetId);

  return (
    <>
      <header className="border-b border-background-elevated bg-background-secondary/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="flex items-center justify-between h-16">
            {/* Hamburger menu button */}
            <button
              type="button"
              onClick={() => setIsMenuOpen(true)}
              className="p-2 -ml-2 rounded-lg text-text-secondary hover:text-text-primary hover:bg-background-elevated transition-colors"
              aria-label="Open menu"
            >
              <MenuIcon className="w-6 h-6" />
            </button>

            {/* Logo with Ruleset Badge */}
            <Link
              to={`/${rulesetId}`}
              className="flex items-center gap-3 text-text-primary hover:text-accent-gold transition-colors"
            >
              <D20Icon className="w-8 h-8 text-accent-gold" />
              <span className="font-display text-xl font-semibold hidden sm:block">
                AIR RPG
              </span>
              {config && (
                <span className="text-sm px-2 py-0.5 rounded bg-background-elevated text-text-secondary">
                  {config.name}
                </span>
              )}
            </Link>

            {/* Spacer for visual balance */}
            <div className="w-10" />
          </div>
        </div>
      </header>

      <HamburgerMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
}

function MenuIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  );
}

function D20Icon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className={className}
    >
      <polygon points="12,2 22,8.5 22,15.5 12,22 2,15.5 2,8.5" />
      <line x1="12" y1="2" x2="12" y2="22" />
      <line x1="2" y1="8.5" x2="22" y2="15.5" />
      <line x1="22" y1="8.5" x2="2" y2="15.5" />
    </svg>
  );
}

